import { apiRequest } from '../utils/apiClient';
import type { BrokerMapEntry, BrokerListingGeo, BrokerMapType } from '../types/brokerMap';

interface BrokerMapResponse {
  success: boolean;
  data: { brokers: BrokerMapEntry[]; generatedAt: string };
}

interface BrokerListingsResponse {
  success: boolean;
  data: { listings: BrokerListingGeo[] };
}

export async function fetchBrokerMap(
  params: { type?: BrokerMapType; city?: string; verified?: boolean } = {},
): Promise<BrokerMapEntry[]> {
  const qs = new URLSearchParams();
  if (params.type) qs.set('type', params.type);
  if (params.city) qs.set('city', params.city);
  if (params.verified) qs.set('verified', 'true');
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  const res = await apiRequest<BrokerMapResponse>(`/brokers/map${suffix}`);
  return res?.data?.brokers ?? [];
}

export async function fetchBrokerListings(id: string): Promise<BrokerListingGeo[]> {
  const res = await apiRequest<BrokerListingsResponse>(`/brokers/${id}/listings-geo`);
  return res?.data?.listings ?? [];
}
